<template>
    <div class="component-container">
        <div id="box" class="chart-canvas"></div>
        <img class="banner" src="@/assets/images/bg-pic.png" alt="" />
    </div>
</template>
<script>
import * as echarts from "echarts";
import { mapState } from "vuex";
export default {
    data () {
        return {
            inList: [], //车辆进入量
            outList: [], //车辆驶出量
            date: [], //日期
            startVal: 0, //区域缩放的起点值
            endVal: 5, //区域缩放的起点值
            timeId: null, //定时器的id
            myChart: undefined,
        };
    },
    async mounted () {
        this.initChart()
    },
    computed: {
        ...mapState(["dateType"]),
    },
    watch: {
        dateType (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getData();
            }
        },
    },
    destroyed () {
        //清除定时器
        clearInterval(this.timeId);
    },
    methods: {
        // 初始化表
        async initChart () {
            const chartDom = document.getElementById("box");
            this.myChart = echarts.init(chartDom);
            this.getData();
            this.startInterval();
            this.myChart.on("mouseover", () => {
                clearInterval(this.timeId);
            });
            this.myChart.on("mouseout", () => {
                this.startInterval();
            });
        },
        //获取后台的数据
        async getData () {
            await this.$http
                .get("/screen2/getCarInOutVolume?type=" + this.dateType, {})
                .then((response) => {
                    if (response.data.resultCode == 200) {
                        // console.log(response.data, "-------车辆进场--------");
                        this.inList = []
                        this.outList = []
                        this.date = []

                        // 车辆进入量数据
                        const finalList = response.data.inList;
                        finalList.forEach((item, index) => {
                            if (this.dateType == 1 && new Date().getHours() >= Number(item.time)) {  //日
                                this.inList.push(item.result);
                                this.date.push(item.time);
                            }
                            if (this.dateType == 2 && new Date().getDate() >= Number(item.time)) {  //月
                                this.inList.push(item.result);
                                this.date.push(item.time);
                            }
                            if (this.dateType == 3 && new Date().getMonth() + 1 >= Number(item.time)) {  //年
                                this.inList.push(item.result);
                                this.date.push(item.time);
                            }

                        });
                        // 车辆驶出量数据
                        const carOutList = response.data.outList;
                        carOutList.forEach((item, index) => {
                            if (this.dateType == 1 && new Date().getHours() >= Number(item.time)) {  //日
                                this.outList.push(item.result);
                            }
                            if (this.dateType == 2 && new Date().getDate() >= Number(item.time)) {  //月
                                this.outList.push(item.result);
                            }
                            if (this.dateType == 3 && new Date().getMonth() + 1 >= Number(item.time)) {  //年
                                this.outList.push(item.result);
                            }

                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            this.startVal = 0;
            this.endVal = 5;
            this.showValumeEcharts();
        },
        showValumeEcharts () {
            const option = {
                title: {
                    text: "智慧停车实时数据",
                    textStyle: {
                        color: "#04DEFF",
                        fontSize: 19,
                        fontWeight: 800,
                    },
                    left: "17",
                    top: "3",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {},
                    },
                },
                legend: {
                    data: ["驶入量", "驶出量"],
                    top: 25,
                    right: "5%",
                    icon: "roundRect",
                    textStyle: {
                        //图例文字的样式
                        color: "#0CFEEE",
                        fontSize: 20,
                    },
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "10%",
                    top: "25%",
                },
                xAxis: [
                    {
                        type: "category",
                        name: "日期",
                        boundaryGap: false,
                        data: this.date,
                        nameTextStyle: {
                            color: "#0CFEEE",
                            fontSize: 18,
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#fff", //x轴的刻度线颜色
                                fontSize: 18,
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "进出量(次)",
                        splitLine: false,
                        nameTextStyle: {
                            color: "#0CFEEE",
                            fontSize: 16,
                        },
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#fff", //y轴的刻度线颜色
                                fontSize: 17,
                            },
                        },
                    },
                ],
                dataZoom: {
                    show: false,
                    startValue: this.startVal,
                    endValue: this.endVal,
                },
                series: [
                    {
                        name: "驶入量",
                        type: "line",
                        showSymbol: false, //去掉线上的小点
                        areaStyle: {},
                        emphasis: {
                            focus: "series",
                        },
                        smooth: 0.1,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(117, 81, 190, 1)',
                                    },
                                    {
                                        offset: 0.5,
                                        color: 'rgba(117, 81, 190, 1)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(117, 81, 190, 1)',
                                    },
                                ]),
                            },
                        },
                        lineStyle: {
                            width: 1, //设置线条粗细
                        },
                        data: this.inList, //X轴的数据
                    },
                    {
                        name: "驶出量",
                        type: "line",
                        showSymbol: false,
                        areaStyle: {},
                        emphasis: {
                            focus: "series",
                        },
                        smooth: 0.1,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(7, 180, 175, 0.5)',
                                    },
                                    {
                                        offset: 0.5,
                                        color: 'rgba(7, 180, 175, 0.5)',
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(7, 180, 175, 0)',
                                    },
                                ]),
                            },
                        },
                        lineStyle: {
                            width: 1, //设置线条粗细
                        },
                        data: this.outList,
                    },
                ],
            };
            option && this.myChart.setOption(option);
            this.myChart.resize();
        },
        startInterval () {
            // 判断定时器是否存在
            if (this.timeId) {
                clearInterval(this.timeId);
            }
            this.timeId = setInterval(() => {
                this.startVal++;
                this.endVal++;
                if (this.endVal > this.date.length - 1) {
                    this.startVal = 0;
                    this.endVal = 5;
                }
                this.showValumeEcharts();
            }, 5000);
        },
    },
};
</script>

<style scoped>
.component-container {
    background-image: url(@/assets/images/bg-vehicle.png);
}
#bg-pic {
    position: absolute;
    top: 20px;
    left: 4%;
    opacity: 0.55;
}
</style>
